<template>
  <div class="step-finish">
    <h2 class="title">Incluir Consulta</h2>
    <p class="description">Ao salvar, você irá incluir essa consulta à template e, caso queira, poderá adicionar novas consultas.</p>

    <div class="fields">
      <confirmation-field
        v-for="field in sharedFields"
        :key="field.name"
        :label="field.label"
        :value="form[field.name]"
        :options="field.values"
      />
    </div>

    <div
      class="group-fields"
      v-for="group in exclusiveFieldsGrouped"
      :key="group.name"
    >
      <div class="fields">
        <confirmation-field
          v-for="field in group.fields"
          :key="field.name"
          :label="field.label"
          :value="form[field.name]"
          :options="field.values"
        />
      </div>
    </div>
  </div>
</template>

<script>
import newQueryFormFields from '@/template/mixins/newQueryFormFields';
import ConfirmationField from '@/template/components/new-query/step-finish/ConfirmationField.vue';

export default {
  name: 'StepFinish',

  props: {
    tag: {
      type: String,
      required: true,
    },
    form: {
      type: Object,
      required: true,
    },
  },

  model: {
    prop: 'form',
    event: 'input',
  },

  mixins: [
    newQueryFormFields,
  ],

  components: {
    ConfirmationField,
  },
};
</script>

<style lang="scss" scoped>
  .step-finish {
    > .title {
      @apply text-3xl;
      @apply text-center;
    }

    > .description {
      @apply pb-4;
      @apply text-sm;
      @apply text-center;
    }

    > .fields,
    > .groupFields > .fields {
      @apply border-opacity-50;
      @apply border-t-2;
      @apply border-gray-100;
    }
  }
</style>
